import isObject from '../isObject';

// ----------------------------------------------------------------------------

function isEmptyObject(value: unknown): boolean {
    if (!isObject(value)) {
        return true;
    }

    return Object.keys(value as Record<string, unknown>).length === 0;
}

// ----------------------------------------------------------------------------

export default isEmptyObject;
